import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";
import { __awaiter } from "tslib";
import { OfflineContext } from "../../core/context/OfflineContext";
/**
 * Render a segment of the oscillator to an offline context and return the results as an array
 */

export function generateWaveform(instance, length) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var duration, context, clone, buffer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            duration = length / instance.context.sampleRate;
            context = new OfflineContext(1, duration, instance.context.sampleRate);
            clone = new instance.constructor(Object.assign(instance.get(), {
              // should do 2 iterations
              frequency: 2 / duration,
              // zero out the detune
              detune: 0,
              context: context
            })).toDestination();
            clone.start(0);
            _context.next = 6;
            return context.render();

          case 6:
            buffer = _context.sent;
            return _context.abrupt("return", buffer.getChannelData(0));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}